import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import DashboardCard from './DashboardCard';
import { KpiLabel, KpiValue } from '../styles';
import { formatNumber, formatPercent } from '../constants';

// Kart 7/7 — Mülakat sağlığı: planlanan/tamamlanan/katılmayan/iptal + iki
// oran (noShowRate, cancelRate). Oranlar payda sıfırken backend `null` döner
// → "—", "%0" GÖSTERİLMEZ (formatPercent).
const Grid6 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Tile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid #E8ECF0;
  border-radius: 6px;
`;

export default function InterviewHealthCard({ data, loading }) {
  const { t, i18n } = useTranslation();

  return (
    <DashboardCard
      cardKey="mulakat-sagligi"
      title={t('atsDashboard.interviewHealth.title')}
      meta={t('atsDashboard.interviewHealth.meta')}
      span={5}
      spanMd={6}
      loading={loading}
      empty={!data}
      domId="ats-dash-interview-health"
    >
      <Grid6>
        <Tile>
          <KpiLabel>{t('atsDashboard.interviewHealth.scheduled')}</KpiLabel>
          <KpiValue>{formatNumber(data?.scheduled, i18n.language)}</KpiValue>
        </Tile>
        <Tile>
          <KpiLabel>{t('atsDashboard.interviewHealth.completed')}</KpiLabel>
          <KpiValue>{formatNumber(data?.completed, i18n.language)}</KpiValue>
        </Tile>
        <Tile>
          <KpiLabel>{t('atsDashboard.interviewHealth.noShow')}</KpiLabel>
          <KpiValue>{formatNumber(data?.noShow, i18n.language)}</KpiValue>
        </Tile>
        <Tile>
          <KpiLabel>{t('atsDashboard.interviewHealth.cancelled')}</KpiLabel>
          <KpiValue>{formatNumber(data?.cancelled, i18n.language)}</KpiValue>
        </Tile>
        <Tile>
          <KpiLabel>{t('atsDashboard.interviewHealth.noShowRate')}</KpiLabel>
          <KpiValue>{formatPercent(data?.noShowRate, i18n.language)}</KpiValue>
        </Tile>
        <Tile>
          <KpiLabel>{t('atsDashboard.interviewHealth.cancelRate')}</KpiLabel>
          <KpiValue>{formatPercent(data?.cancelRate, i18n.language)}</KpiValue>
        </Tile>
      </Grid6>
    </DashboardCard>
  );
}
